import React from 'react'
import landingPage from '../assets/Manage-landing-page.jpg'
import StartPage from '../assets/StartPage.png'
import huddleCurve from '../assets/Huddle-page.jpg'
import bootstrapPage from '../assets/bootstrap-page.png'
import easyBank from '../assets/easybank.jpg'
import huddle from '../assets/huddle.png'
import todoApp from '../assets/todoApp.png'
import netflix from '../assets/netflix-clone.png'
import growdata from '../assets/growData.png'
import countryApi from '../assets/color-api.jpg'
import productPage from '../assets/ecommerce-product-page.jpg'
import imageCarousel from '../assets/imageCarousel.png'
import bookLib from "../assets/booklib.png" 

import { AiFillGithub } from 'react-icons/ai'
import { AiOutlineDesktop } from 'react-icons/ai'

export const Projects = () => {
    return (

        <section>
            {/* Some Things I’ve Built Section */}

            <div className="bg-[#021227] px-7 sm:px-14 py-16 max-w-screen-xl mx-auto" id="projects">
                <div className="flex items-center justify-center gap-12 pb-12">
                    <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                    <h2 className="text-4xl font-bold text-center">Some Things I’ve Built</h2>
                    <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                </div>

                {/* <!-- featured projects --> */}

                {/* <!-- featured project 01 --> */}
                <div className="flex flex-col sm:flex-row sm:gap-12 mt-20">

                    {/* <!-- left side --> */}
                    <div className="mockup-window border border-base-300 sm:w-1/2 h-[300px] order-2	sm:order-none">
                        <div className="featured-project-img-01-div cursor-all-scroll overflow-scroll h-[300px] rounded">
                            <div className="featured-project-img-01  transition-all	duration-500  ">
                                <img src={landingPage} alt="Landing-Page" className="" />
                            </div>
                        </div>
                    </div>

                    {/* <!-- right side --> */}
                    <div className="sm:w-1/2 h-[300px] flex flex-col justify-center order-1 sm:order-none">
                        <h2 className="sm:text-end text-3xl font-bold mb-8 sm:relative sm:right-[10%] lg:right-1/4">01. Manage Landing Page
                        </h2>
                        <p
                            className="bg-[#051830] pl-8 pr-2 py-4 mb-2 rounded shadow-sm sm:relative sm:right-[10%] lg:right-1/4 text-[#ffffff78]">
                            This is a Project from "Frontend Mentor, built using HTML5 and Tailwind CSS <br />
                            <span className="text-[#309543] font-medium">This Site is Fully Responsive</span>
                        </p>
                        <div style={{ fontFamily: "'Roboto Mono', monospace;" }} className="sm:relative sm:right-[10%] lg:right-1/4">
                            <ul className="flex gap-4 sm:justify-end text-sm">
                                <li>HTML5</li>
                                <li>Tailwind CSS</li>
                            </ul>
                        </div>
                        <div className="flex gap-4 mt-2 sm:justify-end sm:relative sm:right-[10%] lg:right-1/4">
                            <a href="https://github.com/BrainiacDev/Tailwind-Landing-Page" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                            <a href="https://tailwinddev-page.netlify.app" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                        </div>
                    </div>

                </div>

                {/* <!-- featured project 02 --> */}
                <div className="flex flex-col sm:flex-row sm:gap-12 mt-20 sm:mt-20">

                    {/* <!-- right side --> */}
                    <div className="sm:w-1/2 h-[300px] flex flex-col justify-center">
                        <h2 className=" text-3xl font-bold mb-8 sm:relative sm:left-[10%] lg:left-1/4">02. Start Multi-page Website
                        </h2>
                        <p
                            className="bg-[#051830] pl-8 pr-2 py-4 mb-2 rounded shadow-sm sm:relative sm:left-[10%] lg:left-1/4 z-40 text-[#ffffff78]">
                            This is a project given during internship, build using HTML5, CSS3 and JavaScript. <br />
                            <span className="text-[#309543] font-medium">This Site is Fully Responsive</span>
                        </p>
                        <div style={{ fontFamily: "'Roboto Mono', monospace;" }} className="sm:relative sm:left-[10%] lg:left-1/4">
                            <ul className="flex gap-4 justify-start text-sm">
                                <li>HTML5</li>
                                <li>CSS3</li>
                                <li>JavaScript</li>
                            </ul>
                        </div>
                        <div className="flex gap-4 mt-2 justify-start sm:relative sm:left-[10%] lg:left-1/4">
                            <a href="https://github.com/BrainiacDev/Responsive-website" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                {/* <ion-icon name="logo-github" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                            <a href="https://responsive-multi-page-website.netlify.app/" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                {/* <ion-icon name="desktop-outline" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                        </div>
                    </div>

                    {/* <!-- left side --> */}
                    <div className="mockup-window border border-base-300 sm:w-1/2 h-[300px]">
                        <div className="featured-project-img-01-div cursor-all-scroll overflow-scroll h-[300px] rounded">
                            <div className="featured-project-img-01  transition-all	duration-500  ">
                                <img src={StartPage} alt="Start-Page" className="" />
                            </div>
                        </div>
                    </div>

                </div>

                {/* <!-- featured project 03 --> */}
                <div className="flex flex-col sm:flex-row sm:gap-12 mt-20 sm:mt-20">

                    {/* <!-- left side --> */}
                    <div className="mockup-window border border-base-300 sm:w-1/2 h-[300px] order-2 sm:order-none	">
                        <div className="featured-project-img-01-div cursor-all-scroll overflow-scroll h-[300px] rounded">
                            <div className="featured-project-img-01  transition-all	duration-500  ">
                                <img src={bootstrapPage} alt="Bootstrap-Page" />
                            </div>
                        </div>
                    </div>

                    {/* <!-- right side --> */}
                    <div className="sm:w-1/2 h-[300px] flex flex-col justify-center">
                        <h2 className="sm:text-end text-3xl font-bold mb-8 sm:relative sm:right-[10%] lg:right-1/4">03. Landing Page
                        </h2>
                        <p
                            className="bg-[#051830] pl-8 pr-2 py-4 mb-2 rounded shadow-sm sm:relative sm:right-[10%] lg:right-1/4 text-[#ffffff78]">
                            This is an assignment given in "Bootstrap Web Developer Bootcamp", built using
                            HTML5,
                            CSS3 and Bootstrap. <br />
                            <span className="text-[#309543] font-medium">This Site is Fully Responsive</span>
                        </p>
                        <div style={{ fontFamily: "'Roboto Mono', monospace;" }} className="sm:relative sm:right-[10%] lg:right-1/4">
                            <ul className="flex gap-4 sm:justify-end text-sm">
                                <li>HTML</li>
                                <li>CSS</li>
                                <li>Bootstrap5</li>
                            </ul>
                        </div>
                        <div className="flex gap-4 mt-2 sm:justify-end sm:relative sm:right-[10%] lg:right-1/4">
                            <a href="https://github.com/BrainiacDev/HTML-CSS-Bootstrap-landing-page" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                {/* <ion-icon name="logo-github" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                            <a href="https://html-css-bootstrap-landing-page.netlify.app" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                {/* <ion-icon name="desktop-outline" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                        </div>
                    </div>

                </div>

                {/* <!-- featured project 04 --> */}
                <div className="flex flex-col sm:flex-row sm:gap-12 mt-20 sm:mt-20">

                    {/* <!-- right side --> */}
                    <div className="sm:w-1/2 h-[300px] flex flex-col justify-center">
                        <h2 className=" text-3xl font-bold mb-8 sm:relative sm:left-[10%] lg:left-1/4">04. Hudddle landing page</h2>
                        <p
                            className="bg-[#051830] pl-8 pr-2 py-4 mb-2 rounded shadow-sm sm:relative sm:left-[10%] lg:left-1/4 z-40 text-[#ffffff78]">
                            This Huddle landing page is a Fully Responsive website from frontend mentor, built using HTML5 and CSS3. <br />
                            <span className="text-[#309543] font-medium">This Site is Fully Responsive</span>
                        </p>
                        <div style={{ fontFamily: "'Roboto Mono', monospace;" }} className="sm:relative sm:left-[10%] lg:left-1/4">
                            <ul className="flex gap-4 justify-start text-sm">
                                <li>HTML</li>
                                <li>CSS</li>
                            </ul>
                        </div>
                        <div className="flex gap-4 mt-2 justify-start sm:relative sm:left-[10%] lg:left-1/4">
                            <a href="https://github.com/BrainiacDev/Landing-page" target="_blank" rel="noopener noreferrer"
                                className="w-9 h-9">
                                {/* <ion-icon name="logo-github" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                            <a href="https://huddle-curve-landing-page.netlify.app/" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                {/* <ion-icon name="desktop-outline" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                        </div>
                    </div>

                    {/* <!-- left side --> */}
                    <div className="mockup-window border border-base-300 sm:w-1/2 h-[300px]">
                        <div className="featured-project-img-01-div cursor-all-scroll overflow-scroll h-[300px] rounded">
                            <div className="featured-project-img-01  transition-all	duration-500  ">
                                <img src={huddleCurve} alt="huddle" />
                            </div>
                        </div>
                    </div>

                </div>

                {/* <!-- featured project 05 --> */}
                <div className="flex flex-col sm:flex-row sm:gap-12 mt-20 sm:mt-20">

                    {/* <!-- left side --> */}
                    <div className="mockup-window border border-base-300 sm:w-1/2 h-[300px] order-2 sm:order-none	">
                        <div className="featured-project-img-01-div cursor-all-scroll overflow-scroll h-[300px] rounded">
                            <div className="featured-project-img-01  transition-all	duration-500  ">
                                <img src={easyBank} alt="Bootstrap-Page" />
                            </div>
                        </div>
                    </div>

                    {/* <!-- right side --> */}
                    <div className="sm:w-1/2 h-[300px] flex flex-col justify-center">
                        <h2 className="sm:text-end text-3xl font-bold mb-8 sm:relative sm:right-[10%] lg:right-1/4">05. Easybank Landing Page
                        </h2>
                        <p
                            className="bg-[#051830] pl-8 pr-2 py-4 mb-2 rounded shadow-sm sm:relative sm:right-[10%] lg:right-1/4 text-[#ffffff78]">
                            Easybank landing page is a Fully Responsive website from frontend mentor, built using HTML5 and CSS3. <br />
                            <span className="text-[#309543] font-medium">This Site is Fully Responsive</span>
                        </p>
                        <div style={{ fontFamily: "'Roboto Mono', monospace;" }} className="sm:relative sm:right-[10%] lg:right-1/4">
                            <ul className="flex gap-4 sm:justify-end text-sm">
                                <li>HTML</li>
                                <li>CSS</li>
                            </ul>
                        </div>
                        <div className="flex gap-4 mt-2 sm:justify-end sm:relative sm:right-[10%] lg:right-1/4">
                            <a href="https://github.com/BrainiacDev/easyBank-landing-page" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                            <a href="https://easybank-landing-web-page.netlify.app/" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                        </div>
                    </div>

                </div>

                {/* <!-- featured project 06 --> */}
                <div className="flex flex-col sm:flex-row sm:gap-12 mt-20 sm:mt-20">

                    {/* <!-- right side --> */}
                    <div className="sm:w-1/2 h-[300px] flex flex-col justify-center">
                        <h2 className=" text-3xl font-bold mb-8 sm:relative sm:left-[10%] lg:left-1/4">06. Book Library API page</h2>
                        <p
                            className="bg-[#051830] pl-8 pr-2 py-4 mb-2 rounded shadow-sm sm:relative sm:left-[10%] lg:left-1/4 z-40 text-[#ffffff78]">
                            This a Book Library Api page, built using HTML5, CSS3 and Reactjs. <br />
                            <span className="text-[#309543] font-medium">This Site is Fully Responsive</span>
                        </p>
                        <div style={{ fontFamily: "'Roboto Mono', monospace;" }} className="sm:relative sm:left-[10%] lg:left-1/4">
                            <ul className="flex gap-4 justify-start text-sm">
                                <li>HTML</li>
                                <li>CSS</li>
                                <li>Reactjs</li>
                            </ul>
                        </div>
                        <div className="flex gap-4 mt-2 justify-start sm:relative sm:left-[10%] lg:left-1/4">
                            <a href="https://github.com/BrainiacDev/book-library" target="_blank" rel="noopener noreferrer"
                                className="w-9 h-9">
                                {/* <ion-icon name="logo-github" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                            <a href="https://bookslib-page.netlify.app" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                {/* <ion-icon name="desktop-outline" className="w-8 h-8 transition-all hover:text-[#309543]"></ion-icon> */}
                                <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                            </a>
                        </div>
                    </div>

                    {/* <!-- left side --> */}
                    <div className="mockup-window border border-base-300 sm:w-1/2 h-[300px]">
                        <div className="featured-project-img-01-div cursor-all-scroll overflow-scroll h-[300px] rounded">
                            <div className="featured-project-img-01  transition-all	duration-500  ">
                                <img src={bookLib} alt="huddle" />
                            </div>
                        </div>
                    </div>

                </div>

            </div>


            {/* <!-- Honorable Mentions --> */}
            <div className="mt-20">
                <h2 className="text-center text-3xl font-semibold">Honorable Mentions</h2>

                {/* <!-- projects --> */}

                <div className=" px-5 py-24">
                    <div className="flex flex-wrap gap-y-4 -m-4">

                        {/* <!-- project 06 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="business-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={countryApi} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-bold text-indigo-500 mb-1">Reactjs and CSS3</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">Country Api</h1>
                                    <p className="leading-relaxed">
                                        This CountryApi landing page is a Fully Responsive website from frontend mentor, built using Reactjs and CSS3.
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/rest-api-countries" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://business-landing-page-0012.netlify.app/" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- project 12 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="developer-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={productPage} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-medium text-indigo-500 mb-1">HTML CSS Javascript</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">Ecommerce product page</h1>
                                    <p className="leading-relaxed">
                                        This Ecommerce product page, Fully Responsive website from frontend mentor, built using HTML5, CSS3 and Javascript.
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/Ecommerce-product-page" target="_blank" rel="noopener noreferrer"
                                            className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://developer-landing-page-009.netlify.app/" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- project 07 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="developer-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={huddle} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-medium text-indigo-500 mb-1">HTML CSS</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">Huddle alternate feature landing page</h1>
                                    <p className="leading-relaxed">
                                        This Huddle landing page is a Fully Responsive website from frontend mentor, built using HTML5, CSS3
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/huddle-alternate-feature-page" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://github.com/prakash-naikwadi/paytm-clone" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- project 07 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="web-hosting-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={netflix} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-medium text-indigo-500 mb-1">HTML CSS Javascript</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">Netflix Clone</h1>
                                    <p className="leading-relaxed">
                                        This is a personal project to showcase my skills, built using
                                        HTML5, CSS3 and Javascript.
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/netflix-clone" rel="noopener noreferrer" target="_blank"
                                            className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://web-hosting-landing-page-11.netlify.app/" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- project 08 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="product-designer-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={growdata} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-bold text-indigo-500 mb-1">Reactjs and Tailwind CSS</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">Growdata landing page</h1>
                                    <p className="leading-relaxed">
                                        This is a personal project to showcase my skills, built using
                                        Reactjs and Tailwind CSS.
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/Finance-project" rel="noopener noreferrer" target="_blank"
                                            className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://finance-project-web.netlify.app" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- project 09 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="dance-home-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={todoApp} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-bold text-indigo-500 mb-1">HTML5 CSS3 Javascript.</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">TodoApp website</h1>
                                    <p className="leading-relaxed">
                                        This is a personal project to showcase my skills, built using
                                        HTML5, CSS3 and Javascript.
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/todoApp" target="_blank" rel="noopener noreferrer"
                                            className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://dance-home-page-014.netlify.app/" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <!-- project 10 --> */}
                        <div className=" lg:w-1/3 sm:w-1/2 p-4 bg-[#051830]">
                            <div className="flex relative mentions-project rounded-md">
                                <img alt="saas-landing-page"
                                    className="absolute inset-0 w-full h-full object-cover object-center rounded-md"
                                    src={imageCarousel} />
                                <div className="px-8 py-10 relative z-10 w-full bg-[#051830] transition-all opacity-0 hover:opacity-95">
                                    <h2 className="tracking-widest text-sm title-font font-bold text-indigo-500 mb-1">HTML CSS Javascript</h2>
                                    <h1 className="title-font text-lg font-medium text-white mb-3">Image Carousel</h1>
                                    <p className="leading-relaxed">
                                        This is a personal project to showcase my skills, built using
                                        HTML5, CSS3 and Javascript.
                                    </p>
                                    <div className="flex gap-4 mt-2 justify-start">
                                        <a href="https://github.com/BrainiacDev/image-carousel" target="_blank" rel="noopener noreferrer" className="w-9 h-9">
                                            <AiFillGithub className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a>
                                        {/* <a href="https://saas-landing-page-0013.netlify.app/" target="_blank" className="w-9 h-9">
                                            <AiOutlineDesktop className="w-8 h-8 transition-all hover:text-[#309543]" />
                                        </a> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </section>
    )
}
